import React from 'react';

import { useSelector } from 'react-redux';

import FormSection from 'components/Layouts/Form/FormSection';
import { PAGE_TYPE_PROPERTY } from 'constants/index';
import { pageDataSelector } from 'store/page/selectors';

import Property from '../../PageTypes/Property/Resources';

const pageTypeComponentsMap = {
  [PAGE_TYPE_PROPERTY]: Property,
};

function Resources() {
  const page = useSelector(pageDataSelector);
  const PageTypeComponent = pageTypeComponentsMap[page.type];

  return PageTypeComponent ? (
    <FormSection>
      <PageTypeComponent />
    </FormSection>
  ) : null;
}

export default Resources;
